<template>
  <b-modal v-model="localIsShowingModal" @hidden="localIsShowingModal = false" title="Confirmer" centered hide-footer>
    <p>
      {{ `Confirm the deletion of the ${type}` }}
      <strong>{{ name }}</strong>
      {{ "and all the data related" }}.
    </p>

    <p>
      <strong>{{ "This action cannot be undone." }}</strong>
    </p>

    <div class="border-top mt-4 pb-4" />

    <div class="text-right">
      <b-button @click="localIsShowingModal = false" variant="transparent">Annuler</b-button>
      <b-button @click="$emit('confirm')" :disabled="isSending" variant="danger">Supprimer</b-button>
    </div>
  </b-modal>
</template>

<script>
import { BModal, BButton } from "bootstrap-vue";

export default {
  name: "ModalRemove",
  components: { BModal, BButton },
  props: {
    name: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      required: true,
    },

    isShowingModal: {
      type: Boolean,
      default: false,
    },
    isSending: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    localIsShowingModal: {
      get() {
        return this.isShowingModal;
      },
      set(value) {
        this.$emit("update:is-showing-modal", value);
      },
    },
  },
};
</script>
